/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { HasPermissionService } from 'app/shared/services/haspermission.service';
import { AppRoute } from '../../../shared/app.routes';

export const defaultNavigation: FuseNavigationItem[] = [
  // {
  //     id   : 'example',
  //     title: 'Example Demo',
  //     type : 'basic',
  //     icon : 'heroicons_outline:chart-pie',
  //     link : '/example'
  // },

  {
    id: 'policyselection',
    title: 'Policy & Controls Management',
    type: 'basic',
    icon: 'dashboard',
    link: AppRoute.policySelectionRoute,
  },
 
  {
    id: 'clientusers',
    title: 'Users',
    type: 'basic',
    link: 'main/clientuser/',
    icon: 'account_circle',
  },
    {
    
    id: 'RiskIntegrator',
    title: 'Risk Integrator',
    type: 'basic',
    icon: 'format_list_numbered',
    link: AppRoute.riskIntegrator,
  },
  {
    id: 'assessment',
    icon: 'assessment',
    title: 'Assessment',
    type: 'basic',
    link: AppRoute.assessmentListRoute,
  },
  {
    id: 'assessmentdashboard',
    title: 'Assessment Dashboard',
    type: 'basic',
    icon: 'dashboard',
    link: AppRoute.assessmenDashboard,

    //ignoreChildUrl: ["/comparison"],
  },
  {
    id: 'dashboarduser',
    title: 'Dashboard',
    type: 'basic',
    icon: 'dashboard',
    link: 'main/dashboard/client-user',
  },
  {
    id: 'infosec',
    title: 'Remediation Project',
    type: 'collapsable',
    icon: 'assignment_late',
    children: [
      {
        id: 'myproject',
        title: 'Project List',
        type: 'basic',
        link: 'main/infosec/',
        //ignoreChildUrl: ["/timesheet", '/taskreport']
      },
      {
        id: 'myproject',
        title: '',
        type: 'basic',
        link: 'main/infosec/list',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'myproject',
        title: '',
        type: 'basic',
        link: 'main/infosec/add',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'myproject',
        title: '',
        type: 'basic',
        link: 'main/infosec/edit',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'myproject',
        title: '',
        type: 'basic',
        link: 'main/infosec/view',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'project',
        title: '',
        type: 'basic',
        link: 'main/infosec/task/list',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'project',
        title: '',
        type: 'basic',
        link: 'main/infosec/hoursrequest/add',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'project',
        title: '',
        type: 'basic',
        link: 'main/infosec/timesheet/list/all',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'project',
        title: '',
        type: 'basic',
        link: 'main/infosec/hoursHistory/list',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'projectresource',
        title: 'Resource Report',
        type: 'basic',
        link: 'main/projectresource/list', //list added
      },
      {
        id: 'taskreport',
        title: 'Task Report',
        type: 'basic',
        link: AppRoute.projectTaskResource,
      },
      {
        id: 'timesheet',
        title: 'Time Sheet',
        type: 'basic',
        link: AppRoute.projectTimesheetListRoute,
        //matchUrl: 'infosec/timesheet/'
      },
      {
        id: 'timesheet',
        title: '',
        type: 'basic',
        link: 'main/infosec/timesheet/add',
        hidden: (item: FuseNavigationItem) => true
      },
      {
        id: 'myproject',
        title: 'My Project',
        type: 'basic',
        link: AppRoute.myproject,
      },
    ],
  },
  {
    id: 'infosecdashboardalluser',
    title: 'Remediation Dashboard',
    type: 'basic',
    link: AppRoute.infosecDashboardAllUser,
    icon: 'dashboard',
  },
  {
    id: 'remediation',
    icon: 'format_list_numbered',
    title: 'Risk Reassessment',
    type: 'basic',
    link: AppRoute.remediationListRoute,
  },
  {
    id: 'dashboard2',
    title: 'Assessment Comparison',
    type: 'basic',
    icon: 'dashboard',
    link: 'main/dashboard/comparison',
  },
  {
    id: 'clientlibrary',
    icon: 'library_books',
    title: 'Manage Organization Policy',
    type: 'basic',
    link: AppRoute.questionnairImportRouteCompany,
  },

  {
    id: 'clientquestionnairelist',
    icon: 'question_answer',
    title: 'Add Questionnaire',
    type: 'basic',
    link: AppRoute.clientQuestionnaireListRoute,
    //ignoreChildUrl: ['/main/clientquestion/import']
  },
  {
    id: 'clientdocument',
    icon: 'insert_drive_file',
    title: 'File Management',
    type: 'basic',
    link: AppRoute.clientDocumentListRoute,
  },
  {
    id: 'vulnerabilitymangement',
    title: 'Vulnerability Dashboard',
    type: 'basic',
    link: 'javascript:void(0);',
    icon: 'security',
  },
  {
    
    id: 'Payment',
    title: 'Payment',
    type: 'basic',
   icon: 'payment',

    link: AppRoute.paymentPlan,
  },
  // {
  //   id: 'setupsubscription',
  //   icon: 'group_work',
  //   title: 'Subscription',
  //   type: 'basic',
  //   link: AppRoute.manageSubscriptionListRoute,
  //   //hidden: (item: FuseNavigationItem) => printdata(item.link),

  //   //hidden: (item: FuseNavigationItem) =>!IsPermission('main/subscription/list'),
  //   //hidden: (item: FuseNavigationItem) =>!hasPermission('setupsubscription', 'view'),
  //   //hidden: (item: FuseNavigationItem) => !hasPermission('assessment'),
  // },

  {
    id: 'manageclientconfiguration',
    title: 'Manage Client Configuration',
    type: 'collapsable',
    icon: 'settings_system_daydream',
    children: [
      {
        id: 'editmycompany',
        title: 'Edit My Company',
        type: 'basic',
        link: AppRoute.editmycompany,
      },
      {
        id: 'setupcompanydepartment',
        title: 'Setup Company Department',
        type: 'basic',
        link: AppRoute.companyDepartmentListRoute, //"master/companydepartments/listcompanydepartment"
      },
    ],
  },

  {
    id: 'systemconfiguration', //infosecdashboardalluser
    title: 'System Configuration',
    type: 'collapsable',
    icon: 'settings_system_daydream',
    children: [
      {
        id: 'roleManagement', //systemrolemanagement
        title: 'Role Management',
        type: 'basic',
        link: AppRoute.roleManagementRoute,
      },
      {
        id: 'users',
        title: 'Users',
        type: 'collapsable',
        children: [
          {
            id: 'systemUsers',
            title: 'System Users',
            type: 'basic',
            link: AppRoute.userList,
          },
          {
            id: 'systemUsers',
            title: '',
            type: 'basic',
            link: AppRoute.userAdd,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'systemUsers',
            title: '',
            type: 'basic',
            link: AppRoute.userEdit,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'systemUsers',
            title: '',
            type: 'basic',
            link: AppRoute.userViewRoute,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'systemUsers',
            title: '',
            type: 'basic',
            link: AppRoute.assignCompany,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'experts',
            title: 'BS Experts',
            type: 'basic',
            link: AppRoute.bsExpertList,
          },
          {
            id: 'experts',
            title: '',
            type: 'basic',
            link: AppRoute.bsExpertAdd,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'experts',
            title: '',
            type: 'basic',
            link: AppRoute.bsExpertEdit,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'experts',
            title: '',
            type: 'basic',
            link: AppRoute.bsExpertView,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'experts',
            title: '',
            type: 'basic',
            link: AppRoute.bsExpertassignCompany,
            hidden: (item: FuseNavigationItem) => true
          },
          {
            id: 'experts',
            title: '',
            type: 'basic',
            link: AppRoute.bsexportReport,
            hidden: (item: FuseNavigationItem) => true
          },
        ],
      },
      {
        id: 'managelibrary',
        title: 'Manage Library',
        type: 'collapsable',
        children: [
          {
            id: 'questioncategory',
            title: 'Main Document',
            type: 'basic',
            link: AppRoute.questionCategoryList,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/view',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/edit',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/companypolicy/list',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/companypolicy/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/companypolicy/procedure/list',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questioncategory',
            title: '',
            type: 'basic',
            link: 'master/questioncategory/companypolicy/procedure/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'maintitle',
            title: 'Main Title',
            type: 'basic',
            link: AppRoute.mainTitleListRoute,
          },
          {
            id: 'maintitle',
            title: '',
            type: 'basic',
            link: 'master/maintitle/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'maintitle',
            title: '',
            type: 'basic',
            link: 'master/maintitle/edit',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'maintitle',
            title: '',
            type: 'basic',
            link: 'master/maintitle/view',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'subtitle',
            title: 'Sub Title',
            type: 'basic',
            link: AppRoute.subTitleListRoute,
          },
          {
            id: 'subtitle',
            title: '',
            type: 'basic',
            link: 'master/subtitle/view',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'subtitle',
            title: '',
            type: 'basic',
            link: 'master/subtitle/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'subtitle',
            title: '',
            type: 'basic',
            link: 'master/subtitle/edit',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'policy',
            title: 'Policy',
            type: 'basic',
            link: AppRoute.policyListRoute,
          },
          {
            id: 'policy',
            title: '',
            type: 'basic',
            link: 'master/policy/view',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'policy',
            title: '',
            type: 'basic',
            link: 'master/policy/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'policy',
            title: '',
            type: 'basic',
            link: 'master/policy/edit',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questionnairelist',
            title: 'Questionnaires',
            type: 'basic',
            link: AppRoute.questionnaireListRoute,
            //ignoreChildUrl: ['/main/question/import']
          },
          {
            id: 'questionnairelist',
            title: 'Questionnaires',
            type: 'basic',
            link: 'main/question/add',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questionnairelist',
            title: 'Questionnaires',
            type: 'basic',
            link: 'main/question/edit',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'questionnairelist',
            title: 'Questionnaires',
            type: 'basic',
            link: 'main/question/view',
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'importquestion',
            title: 'Import Questionnaires',
            type: 'basic',
            link: AppRoute.questionnairImportRoute,
          },
        ],
      },
      {
        id: 'dept',
        title: 'Company Department',
        type: 'basic',
        link: AppRoute.departmentList,
      },
      {
        id: 'dept',
        title: '',
        type: 'basic',
        link: AppRoute.departmentEdit,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'compliance',
        title: 'Compliances',
        type: 'basic',
        link: AppRoute.complianceList,
      },
      {
        id: 'compliance',
        title: '',
        type: 'basic',
        link: AppRoute.complianceAdd,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'compliance',
        title: '',
        type: 'basic',
        link: AppRoute.complianceEdit,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'compliance',
        title: '',
        type: 'basic',
        link: AppRoute.complianceViewRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'importcontrol',
        title: 'Import Control',
        type: 'basic',
        link: AppRoute.importControl,
      },
      {
        id: 'service',
        title: 'Services',
        type: 'basic',
        link: AppRoute.mstServiceListRoute,
      },
      {
        id: 'service',
        title: '',
        type: 'basic',
        link: AppRoute.mstServiceAddRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'service',
        title: '',
        type: 'basic',
        link: AppRoute.mstServiceEditRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'service',
        title: '',
        type: 'basic',
        link: AppRoute.mstServiceViewRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'manageclient',
        title: 'Manage Client',
        type: 'basic',
        link: AppRoute.companyList,
      },
      {
        id: 'manageclient',
        title: '',
        type: 'basic',
        link: AppRoute.companyAddRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'manageclient',
        title: '',
        type: 'basic',
        link: AppRoute.companyEdit,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'manageclient',
        title: '',
        type: 'basic',
        link: AppRoute.companyViewRoute,
        hidden: (item: FuseNavigationItem) => true,
      },

      {
        id: 'manageclient',
        title: '',
        type: 'basic',
        link: AppRoute.clientPermissionRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      // {
      //     id: 'manageclient',
      //     title: 'B',
      //     type: 'basic',
      //     link: AppRoute.editMyCompnayRoute,

      // },
      // {
      //     id: 'manageclient',
      //     title: 'C',
      //     type: 'basic',
      //     link: AppRoute.companyUserList,

      // },

      {
        id: 'manageclient',
        title: '',
        type: 'basic',
        link: AppRoute.companySignUpRoute,
        hidden: (item: FuseNavigationItem) => true,
      },

      {
        id: 'manageSubscription',
        title: 'Manage Subscription',
        type: 'basic',
        link: AppRoute.subscriptionListRoute,
      },
      {
        id: 'manageSubscription',
        title: '',
        type: 'basic',
        link: AppRoute.subscriptionAddRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'manageSubscription',
        title: '',
        type: 'basic',
        link: AppRoute.subscriptionEditRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'manageSubscription',
        title: '',
        type: 'basic',
        link: AppRoute.subscriptionViewRoute,
        hidden: (item: FuseNavigationItem) => true,
      },
      {
        id: 'infosec',
        title: 'Client Projects',
        type: 'collapsable',
        //icon: 'assignment_late',
        children: [
          {
            id: 'manageProject',
            title: 'Project List',
            type: 'basic',
            link: AppRoute.allCompanyProjectList, //"main/allcompanyproject/list"
          },
          {
            id: 'manageProject',
            title: '',
            type: 'basic',
            link: AppRoute.allCompanyProjectTimeSheetListRoute,
            hidden: (item: FuseNavigationItem) => true,
            //allCompanyProjectHoursHistoryListRoute
          },
          {
            id: 'manageProject',
            title: '',
            type: 'basic',
            link: AppRoute.allCompanyProjectHoursHistoryListRoute,
            hidden: (item: FuseNavigationItem) => true,
          },
          {
            id: 'infosecDashboardSysAdmin',
            title: 'Project Status',
            type: 'basic',
            link: AppRoute.infosecDashboardSystemAdmin,
          },
        ],
      },
      {
        id: 'activitylog',
        title: 'Activity Log',
        type: 'basic',
        link: AppRoute.activityLogListRoute,
      },
    ],
  },






];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];

function hasPermission(pageName: string, actionName: string = 'view'): boolean {
  return hasPermissionService?.hasPermission(pageName, actionName) ?? false;
}
// Inject the HasPermissionService
let hasPermissionService: HasPermissionService;

export function setHasPermissionService(service: HasPermissionService) {
  hasPermissionService = service;
}

const getAllTitles = (navigationItems) => {
  const links = [];

  navigationItems.forEach((item) => {
    links.push(item.link);

    if (item.children) {
      const childIds = getAllTitles(item.children);
      links.push(...childIds);
    }
  });

  return links;
};

// Usage
const allTitles = getAllTitles(defaultNavigation);

export function getUniquePageNames(data: any[]): string[] {
  const pageNamesSet = new Set<string>();
  data.forEach((item) => {
    if (item.pageName) {
      pageNamesSet.add(item.pageName);
    }
  });
  return Array.from(pageNamesSet);
}

function hasPermissionForItem(itemId: string): boolean {
  // Get the HasPermissionService instance
  const hasPermissionService = window['injector'].get(HasPermissionService);

  // Convert itemId to lowercase to match API response format
  const id = itemId.toLowerCase();

  // Check if there's any permission in currUserPermissions with matching pageName
  return hasPermissionService.currUserPermissions.some(
    (permission) => permission.pageName.toLowerCase() === id
  );
}

function printdata(url: string): boolean {
  return true;
}
